import React from 'react'
import PropTypes from 'prop-types'
import { AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES } from '../../data/constants'
import { getSubsectionView } from '../../data/scoring'
import SectionHeading from '../../components/SectionHeading/SectionHeading'
import WhyThisMatters from '../../components/WhyThisMatters/WhyThisMatters'
import AppsAndServicePrincipals from './AppsAndServicePrincipals'
import ShadowAi from './ShadowAi'
import TenantAuthz from './TenantAuthz'

export default function ThirdPartyAi({
  summary = {},
  data = {},
  scoring = { sections: [] },
  findings = [],
  dataAvailability = [],
}) {
  const apps = getSubsectionView(scoring, 'appsAndServicePrincipals')
  const shadowAi = getSubsectionView(scoring, 'shadowAi')
  const tenantAuthz = getSubsectionView(scoring, 'tenantAuthz')

  return (
    <>
      <div {...AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES}>
        <SectionHeading
          id="third-party-ai"
          titleId="AI_RISK_REPORT.SECTION.THIRD_PARTY.TITLE"
          questionId="AI_RISK_REPORT.SECTION.THIRD_PARTY.QUESTION"
        />
        <WhyThisMatters bodyId="AI_RISK_REPORT.SECTION.THIRD_PARTY.WHY" />
      </div>
      <ShadowAi
        appsData={data.shadowAiApps}
        usersData={data.shadowAiUsers}
        score={shadowAi.score}
        gap={shadowAi.gap}
        dataAvailability={dataAvailability}
      />
      <AppsAndServicePrincipals
        summary={summary}
        data={data}
        findings={findings}
        score={apps.score}
        gap={apps.gap}
        dataAvailability={dataAvailability}
      />
      <TenantAuthz tenant={data.tenant} score={tenantAuthz.score} gap={tenantAuthz.gap} />
    </>
  )
}

ThirdPartyAi.propTypes = {
  summary: PropTypes.shape({}),
  data: PropTypes.shape({
    applications: PropTypes.arrayOf(PropTypes.shape({})),
    servicePrincipals: PropTypes.arrayOf(PropTypes.shape({})),
    shadowAiApps: PropTypes.shape({
      total: PropTypes.number,
      unsanctionedTotal: PropTypes.number,
      pendingTotal: PropTypes.number,
      items: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    shadowAiUsers: PropTypes.shape({
      total: PropTypes.number,
      discoverUsersTotal: PropTypes.number,
      items: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    listTotals: PropTypes.shape({
      applications: PropTypes.number,
      servicePrincipals: PropTypes.number,
    }),
    tenant: PropTypes.shape({}),
  }),
  scoring: PropTypes.shape({ sections: PropTypes.arrayOf(PropTypes.shape({})) }),
  findings: PropTypes.arrayOf(PropTypes.shape({})),
  dataAvailability: PropTypes.arrayOf(PropTypes.shape({})),
}
